import { EraQL, Expression } from '@cotera/era';
import { ToolCallColumnFormState } from '../tool-call.model';
import { err, ok, Result } from 'neverthrow';

export function getProgramEraQL(
  formState: ToolCallColumnFormState,
  promptExpr: Expression | null
): Result<
  string,
  | {
      t: 'no-tool-selected';
      message: string;
    }
  | {
      t: 'column-referenced-parameters';
      message: string;
    }
  | {
      t: 'no-prompt-expr';
      message: string;
    }
> {
  const tool = formState.tool;
  if (tool === null) {
    return err({
      t: 'no-tool-selected',
      message: 'must have tool selected',
    });
  }

  if (promptExpr === null) {
    return err({
      t: 'no-prompt-expr',
      message: 'must have prompt expression',
    });
  }

  const args = [EraQL.withNullMeta(EraQL.exprToEraQLAst(promptExpr.ir()))];

  const toolName = tool.name.replaceAll('/', '_');

  const fc: EraQL.WithMeta<EraQL.EraQlAst> = EraQL.withNullMeta({
    t: 'call',
    op: EraQL.withNullMeta({
      t: 'symbol' as const,
      sym: toolName,
    }),
    args,
    display: 'fc',
  });

  const rootNode = EraQL.buildNode(fc);

  return ok(EraQL.generateProgram(rootNode));
}
